import BackgroundLayer from '../layers/BackgroundLayer';
import HeadLayer from '../layers/HeadLayer';
import EyesLayer from '../layers/EyesLayer';
import NoseLayer from '../layers/NoseLayer';
import MouthLayer from '../layers/MouthLayer';
import HairThumbnailLayer from '../layers/HairThumbnailLayer';
import AccessoryLayer from '../layers/AccessoryLayer';
import EarsLayer from '../layers/EarsLayer';
import { Category } from 'shared/types';
import * as Colors from 'shared/styles/colors';
import FacialHairLayer from '../layers/FacialHairLayer';
import LogoLayer from '../layers/LogoLayer';

interface Props {
  category: string;
  option: number;
}

const OptionThumbnails = ({ category, option }: Props) => {
  switch (category) {
    case Category.HEAD:
      return (
        <HeadLayer
          colorBase={Colors.orange}
          isThumbnail
        />
      );
    case Category.HAIR:
      return (
        <HairThumbnailLayer
          option={option}
          colorBase={Colors.purple}
        />
      );
    case Category.EYES:
      return (
        <EyesLayer
          option={option}
          isThumbnail
        />
      );
    case Category.NOSE:
      return (
        <NoseLayer
          option={option}
          isThumbnail
        />
      );
    case Category.MOUTH:
      return (
        <MouthLayer
          option={option}
          colorBase={Colors.red}
          isThumbnail
        />
      );
    case Category.EARS:
      return (
        <EarsLayer
          option={option}
          colorBase={Colors.orange}
          isThumbnail
        />
      );
    case Category.FACIAL_HAIR:
      return (
        <FacialHairLayer
          option={option}
          colorBase={Colors.purple}
          isThumbnail
        />
      );
    case Category.ACCESSORIES:
    case Category.ACCESSORIES_EYEWEAR:
    case Category.ACCESSORIES_HEADGEAR:
    case Category.ACCESSORIES_FANFETTI:
      return (
        <AccessoryLayer
          option={option}
          colorBase={Colors.black}
          isThumbnail
        />
      );
    case Category.LOGO:
      return (
        <LogoLayer
          option={option}
          isThumbnail
        />
      );
    case Category.BACKGROUND:
      return (
        <BackgroundLayer
          option={option}
          colorBase={Colors.lightGray}
          isThumbnail
        />
      );
    default:
      // No other possible categories
      return null;
  }
}

export default OptionThumbnails;
